import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Edit one entity type
 * @primary Entity type form
 * @persona danilo-tech
 */
export const Route = createFileRoute(
  "/app/admin/fsm-workflows/entity-types/$id",
)({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
